import { IconButton, Input, SelectPicker } from "rsuite";
import Responsive from "../../../../../Components/Responsive";
import TrashIcon from "@rsuite/icons/Trash";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import { typeTransport } from "../../../../../Constants/types";
import Translation from "../../../../../translation/translation";

const TransportForm = ({
  mode,
  i,
  addNewTransport,
  modeTransports,
  deleteTransport,
  handleInputChangeTransport,
}) => {
  const handlePriceChange = (i, price) => {
    const parsedPrice = parseFloat(price);
    if (parsedPrice >= 0) {
      handleInputChangeTransport(i, "price", parsedPrice);
    }
  };

  return (
    <div>
      <Responsive className="p-5" s={6} m={6} l={3} xl={1.8}>
        <label>{Translation.name}:</label>
        <SelectPicker
          data={typeTransport}
          block
          noSearch
          value={mode.name}
          onChange={(name) => handleInputChangeTransport(i, "name", name)}
        />
      </Responsive>

      <Responsive s={6} m={4} l={2.5} xl={1.3} className="p-5">
        <label>Prix:</label>
        <Input
          type="number"
          step="0.1"
          min="0"
          value={mode.price || 0}
          onChange={(price) => handlePriceChange(i, price)}
        />
      </Responsive>

      <Responsive
        s={2}
        m={1.6}
        l={1}
        xl={1}
        style={{
          gap: "8px",
        }}
      >
        <div style={{ height: "38px" }}></div>
        <IconButton
          onClick={() => deleteTransport(i)}
          color="violet"
          icon={<TrashIcon />}
        />

        {i + 1 === modeTransports.length && (
          <IconButton
            onClick={addNewTransport}
            color="violet"
            icon={<PlusRoundIcon />}
          />
        )}
      </Responsive>
    </div>
  );
};

export default TransportForm;
